import { resolveLoginUrl, type AppUrlContext } from "@authe/fe-commons/auth";
import { urlContext } from "@/config";

/** The signed-out screen belongs to the login SPA, including its separate dev port. */
export function logoutDestination(context: AppUrlContext = urlContext): string {
  return resolveLoginUrl({ params: { loggedout: "1" } }, context);
}
